<!-- @format -->

<shared-ceops></shared-ceops>
<main
	id="app-container"
	class="container-fluid app-container clp-app-container"
	role="main">
	<router-outlet></router-outlet>
</main>
